import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_2 = { class: "w-full mt-5" }
const _hoisted_3 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_5 = { class: "ml-1 relative" }
const _hoisted_6 = { class: "w-full mt-5" }
const _hoisted_7 = { class: "flex flex-row gap-3" }
const _hoisted_8 = { class: "flex text-red-lp-100 gap-1 mt-2" }
const _hoisted_9 = { class: "text-12px" }
const _hoisted_10 = { class: "flex text-red-lp-100 gap-1 mt-2" }
const _hoisted_11 = { class: "text-12px" }
const _hoisted_12 = { class: "text-12px text-gray-lp-600 mt-3" }
const _hoisted_13 = { class: "text-12px text-gray-lp-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_UploadImageTiny = _resolveComponent("UploadImageTiny")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_data_wrapper = _resolveComponent("data-wrapper")!

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_Title, {
      label: _ctx.$t('bookingShipment.column.additionalInformation')
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("p", null, _toDisplayString(_ctx.$t('bookingShipment.column.commodityDetails')), 1),
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("img", {
            onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenTooltip = true)),
            onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenTooltip = false)),
            src: 
                            _ctx.isOpenTooltip
                            ? require('@/app/ui/assets/svg/info-red.svg')
                            : require('@/app/ui/assets/svg/info.svg')
                        ,
            alt: ""
          }, null, 40, ["src"]),
          _withDirectives(_createVNode(_component_Tooltip, {
            title: _ctx.$t('bookingShipment.tooltip.detailCommodity'),
            message: _ctx.$t('bookingShipment.tooltip.detailCommodityMsg'),
            style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
          }, null, 8, ["title", "message"]), [
            [_vShow, _ctx.isOpenTooltip]
          ])
        ])
      ]),
      _createVNode(_component_lp_input, {
        type: "textarea",
        modelValue: _ctx.detailCommodity,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.detailCommodity = $event)),
        placeholder: _ctx.$t('bookingShipment.placeholder.commodityDetails'),
        format: _ctx.replaceNewLine,
        maxLength: 1000,
        showMaxLength: true,
        error: _ctx.errorCommodity,
        errorCaption: _ctx.$t('bookingShipment.error.detailCommodity'),
        onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setFieldIndex(_ctx.indexErrorCommodity)))
      }, null, 8, ["modelValue", "placeholder", "format", "error", "errorCaption"])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_data_wrapper, {
        label: _ctx.$t('bookingShipment.column.logisticsDocumentationPhoto'),
        asterisk: ""
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_7, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.proofPhotos, (photo, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                _createVNode(_component_UploadImageTiny, {
                  title: photo,
                  modelValue: _ctx.attachmentImage[index],
                  "onUpdate:modelValue": ($event: any) => (_ctx.attachmentImage[index] = $event),
                  defaultImage: _ctx.storageImages[index],
                  maxSize: 5,
                  multipleIndex: index,
                  onUpload: _ctx.upload,
                  onRemove: _ctx.remove
                }, null, 8, ["title", "modelValue", "onUpdate:modelValue", "defaultImage", "multipleIndex", "onUpload", "onRemove"])
              ]))
            }), 128))
          ]),
          _withDirectives(_createVNode("div", _hoisted_8, [
            _createVNode(_component_Icons, {
              name: "warning-triangle",
              class: " w-4"
            }),
            _createVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('bookingShipment.validate.uploadPhotos')), 1)
          ], 512), [
            [_vShow, _ctx.errorPhoto || _ctx.validateLimitUpload]
          ]),
          _withDirectives(_createVNode("div", _hoisted_10, [
            _createVNode(_component_Icons, {
              name: "warning-triangle",
              class: " w-4"
            }),
            _createVNode("p", _hoisted_11, _toDisplayString(_ctx.errorMessage), 1)
          ], 512), [
            [_vShow, _ctx.isError]
          ]),
          _createVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('bookingShipment.description.logisticsDocumentationPhotoOne')), 1),
          _createVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('bookingShipment.description.logisticsDocumentationPhotoTwo')), 1)
        ]),
        _: 1
      }, 8, ["label"])
    ])
  ]))
}